import FinalizeFormContainer from './finalize_form_container';

const FinalizeForm = FinalizeFormContainer;
export default FinalizeForm;
